<template>
    <div class="request__contact" style="display: flex; flex-direction: column; flex-grow: 1;position: relative;">
        <app-request-contact-search v-if="!request.zepplinId" :request="request"></app-request-contact-search>
        <div class="request-contact__body" :class="{ 'request-contact__body-zepplin': request.zepplinId }">
            <div class="new-row new-body">
                <div class="new-column new-contato" :class="{ 'disabled': request.zepplinId }">
                    <div>
                        <span class="text-span">Contato / Cliente <span style="color: tomato;">*</span></span>
                    </div>
                    <div style="margin-top: 1px; display: flex; align-items: center">
                        <app-text-input class="input" style="margin-bottom: 0" 
                            autocomplete="nope" placeholder="NOME / EMPRESA" :model="getContact" field="name"></app-text-input>
                        <div v-if="!utils.isTmp(request.requestContact.contactId) && !request.zepplinId" style="cursor: pointer;" @click="deleteContact()">
                            <icon-remove></icon-remove>
                        </div>
                    </div>
                </div>
                <div class="new-column new-telefone">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <span class="text-span" style="font-size: 1em">Telefone</span>
                        <div v-show="getContactPhoneDefault.number && getContactPhoneDefault.number.length > 9" 
                            @click="redirectToWhatsapp(getContactPhoneDefault.number)" style="cursor: pointer">
                            <icon name="whatsapp" color="#CCC"/>
                        </div>
                    </div>
                    <div class="new-row" :class="{ 'disabled': request.zepplinId }" v-for="(contactPhone, index) in request.requestContact.contact.contactPhones" :key="contactPhone.id" style="text-align: left;">
                        <div style="display: flex; align-items: center; padding: 8px 0 2px; margin-right: 8px; cursor: pointer; font-size: 18px;" @click="setContactPhoneDefault(contactPhone)">
                            <fa icon="check" size="sm" v-if="contactPhone.isDefault" style="color: var(--font-color--primary)" />
                            <fa icon="check" size="sm" v-else style="color: var(--font-color--1)" />
                        </div>
                        <app-mask :mask="['(##) ####-####', '(##) #####-####']" :value="contactPhone.number" @input="VXORM.Request.updateModelValue(VXORM.ContactPhone, 'number', contactPhone.id, $event)"
                            placeholder="(##) #####-####" class="input" style="margin-bottom: 0;"></app-mask>
                        <div v-if="!request.zepplinId" style="display: flex; width: 70px; padding: 8px 0 3px; align-items: center; justify-content: flex-end;">
                            <div @click="deleteContactPhone(contactPhone.id)" style="display: flex; justify-content: center; cursor: pointer; font-size: 18px;">
                                <fa icon="minus-square" size="sm" />
                            </div>
                            <div v-if="index === 0" @click="addContactPhone()" style="display: flex; justify-content: center; cursor: pointer; margin-left: 8px; font-size: 18px;">
                                <fa icon="plus-square" size="sm" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div v-show="!contactAddressForm" style="display: flex; justify-content: space-between; align-items: center; margin-top: 10px; ">
                <div class="new-form new-inputs" style="border-bottom: 0; width: 100%; margin-right: 5px;"> 
                    <div style="width: 100%;">
                        <input type="text" style="width: 100%; font-size: .9em; outline: none;" placeholder="Informação adicional"
                            :value="request.requestContact.contact.obs" autocomplete="nope"
                            @input="VXORM.Request.updateModelValue(VXORM.Contact, 'obs', request.requestContact.contactId, $event.target.value.toUpperCase())">
                    </div>
                </div>
                <div class="new-form new-inputs" style="border-bottom: 0; width: 345px; margin-left: 5px;"> 
                    <div style="width: 100%;">
                        <app-mask :mask="['###.###.###-##', '##.###.###/####-##']" :value="request.requestContact.contact.legalDocument" 
                            @input="VXORM.Request.updateModelValue(VXORM.Contact, 'legalDocument', request.requestContact.contactId, $event)"
                            placeholder="CPF/CNPJ" class="input" style="width: 100%; font-size: .9em; outline: none; padding: 0;"></app-mask>
                    </div>
                </div>
            </div>
            <div class="new-row new-body__contact-tabs"> 
                <div class="endereço" :class="{ativo: activeContactTab === 'addresses' }" @click="activeContactTab = 'addresses'">
                    <span>Endereços</span>
                </div>  
                <!-- <div v-if="!request.zepplinId" class="detalhes" :class="{ativo: activeContactTab === 'contactDetails' }" @click="activeContactTab = 'contactDetails'">
                    <span>Detalhes do contato</span>
                </div> -->
            </div>

            <div v-if="activeContactTab === 'addresses'" class="new-form" style="margin-bottom: 10px;">
                <div v-if="!contactAddressForm" >
                    <div v-if="!request.requestContact.contact.contactAddresses.length">
                        <h1>Sem endereços cadastrados.</h1>
                    </div>
                    <div v-else>
                            <table style="width: 100%">
                                <app-perfect-scrollbar style="max-height: 150px;">
                                    <tbody>
                                        <tr v-for="contactAddress in request.requestContact.contact.contactAddresses" :key="contactAddress.id" 
                                            style="margin-bottom: 5px; display: flex; justify-content: space-between; align-items: center;"
                                        >
                                            <td @click="setContactAddressDefault(contactAddress)" style="min-width: 220px; display: flex; align-items: center; cursor: pointer;" > 
                                                <div style="display: inline-block; margin-right: 10px;" v-if="contactAddress.isDefault">
                                                    <icon-request-check></icon-request-check>
                                                </div>
                                                <div :class="{ 'is-default': contactAddress.isDefault }">
                                                    {{ contactAddress.address && contactAddress.address.name ? contactAddress.address.name : 'S/ENDEREÇO' }},
                                                    {{ contactAddress.number ? contactAddress.number : 'S/NUM' }}<br>
                                                    {{ contactAddress.address && contactAddress.address.neighborhood ? contactAddress.address.neighborhood  : 'S/BAIRRO' }}
                                                    {{ contactAddress.complement ? ' - ' + contactAddress.complement : '' }}<br>
                                                    {{ contactAddress.referencePoint ? contactAddress.referencePoint : '' }}
                                                </div>
                                            </td>
                                            <div style="width: 50%"></div>
                                            <td>
                                                <div style="float: left; display: flex; width: 70px;">
                                                    <div style="margin-right: 8px; cursor: pointer;" @click="editContactAddress(contactAddress.id)">
                                                        <icon-request-edit></icon-request-edit>
                                                    </div>
                                                    <div style="cursor: pointer" @click="deleteContactAddress(contactAddress)">
                                                        <icon-delete></icon-delete>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                </app-perfect-scrollbar>
                            </table>
                    </div>
                    <div v-if="!request.zepplinId" style="margin: 0px 5px 0px 5px; float: right">
                        <input class="new_button save-address" type="button"  value="Novo endereço" @click="addContactAddress()">
                    </div>
                </div>
                <div v-if="contactAddressForm">
                    <div class="new-row" style="width: 100%; align-items: center">
                        <div style="width: 100%">
                            <span style=" text-align: left;">Rua, Avenida, Praça...</span> 
                            <div class="new-inputs" >
                                <app-search searchType="addresses" :items="searchedAddresses" :horizontalOffset="-10" style="width:100%;"
                                            :forceVisible="addressForceVisible" :value="contactAddressToEdit.address.name"
                                            @select="selectSearchedAddress($event)">
                                    <template v-slot:input>
                                        <input type="text" class="input" autocomplete="nope" style="outline-style: none;" :value="_.get(contactAddressToEdit, 'address.name', '')" placeholder="Buscar ou criar novo"
                                            @focus="addressForceVisible = true" @blur="addressForceVisible = false" :disabled="contactAddressToEdit.address.isLocked"
                                            @input="updateValueContactAddressToEdit('address', 'name', $event.target.value)">
                                    </template>
                                    <template v-slot:item="slotProps">
                                        <div>
                                            <div>
                                                <v-highlight highlightClassName="highlight" highlightTag="em"
                                                    :searchWords="addressSearchQuery"
                                                    :autoEscape="true" :sanitize="sanitizeSearch"
                                                    :textToHighlight="slotProps.item.source.name" />
                                            </div>
                                            <div>
                                                <v-highlight highlightClassName="highlight" highlightTag="em"
                                                    :searchWords="addressSearchQuery"
                                                    :autoEscape="true" :sanitize="sanitizeSearch"
                                                    :textToHighlight="`${slotProps.item.source.neighborhood} - ${slotProps.item.source.city}/${slotProps.item.source.state}`" />
                                            </div>
                                        </div>
                                    </template>
                                </app-search>
                                <div style=" flex-grow: 1;margin:0px;"></div>
                                <div v-if="!utils.isTmp(contactAddressToEdit.addressId)" style="cursor: pointer;" @click="deleteAddress()">
                                    <icon-remove></icon-remove>
                                </div>
                            </div>   
                            <div></div>
                        </div>

                        <div class="new-column numero">
                            <span style="text-align: left;">Nº <span style="color: tomato;">*</span></span>
                            <div class="new-inputs">
                                <input class="input" type="text" autocomplete="nope" :value="contactAddressToEdit && contactAddressToEdit.number ? contactAddressToEdit.number : ''"
                                    @input="updateValueContactAddressToEdit('contactAddress', 'number', $event.target.value)">
                            </div>   
                        </div>
                    </div>
                    <div class="new-row" style="margin: 16px 0px 0px 0px;">
                        <div class="new-column">
                            <span style="text-align: left;">Complemento ou Cond.</span>
                            <div class="new-inputs" >
                                <input class="input" style="flex-grow: 0; color: white; width: 100%" type="text" autocomplete="nope" placeholder="" 
                                    :value="contactAddressToEdit ? contactAddressToEdit.complement : ''" @input="updateValueContactAddressToEdit('contactAddress', 'complement', $event.target.value)">
                            </div>
                        </div>
                        <div class="new-column" style="margin-left: 15px;">
                            <span style="text-align: left;">Ponto de referência</span>
                            <div class="new-inputs" >
                                <input class="input" style="flex-grow: 0; color: white; width: 100%" type="text" autocomplete="nope" placeholder="" 
                                    :value="contactAddressToEdit ? contactAddressToEdit.referencePoint : ''" @input="updateValueContactAddressToEdit('contactAddress', 'referencePoint', $event.target.value)">
                            </div>
                        </div>
                    </div>
                    <div  class="new-row" style="margin: 16px 0px 0px 0px;">
                        <div class="new_bairro" style="margin: 0px 5px 0px 0px;width: 40%;text-align: left;"><span>Bairro</span>
                            <div>
                                <input class="input" style="max-width: 200px;" type="text" autocomplete="nope"
                                    :value="contactAddressToEdit && contactAddressToEdit.address && contactAddressToEdit.address.neighborhood ? contactAddressToEdit.address.neighborhood : ''"
                                    @input="updateValueContactAddressToEdit('address', 'neighborhood', $event.target.value)"
                                    :disabled="contactAddressToEdit.address.isLocked">
                            </div>
                        </div>
                        <div class="new_bairro" style="margin: 0px 5px 0px 5px;width: 20%;text-align: left;"><span>CEP</span>
                            <div>
                                <input class="input" style="max-width: 93px;"  type="text" autocomplete="nope"
                                    :value="contactAddressToEdit && contactAddressToEdit.address && contactAddressToEdit.address.cep ? contactAddressToEdit.address.cep : ''"
                                    @input="updateValueContactAddressToEdit('address', 'cep', $event.target.value)"
                                    :disabled="contactAddressToEdit.address.isLocked">
                            </div>
                        </div>
                        <div class="new_bairro" style="margin: 0px 5px 0px 5px;width: 35%;text-align: left;"><span>Cidade</span>
                            <div>
                                <input class="input" style="max-width: 190px;" type="text" autocomplete="nope"
                                    :value="contactAddressToEdit && contactAddressToEdit.address && contactAddressToEdit.address.city ? contactAddressToEdit.address.city : ''"
                                    @input="updateValueContactAddressToEdit('address', 'city', $event.target.value)"
                                    :disabled="contactAddressToEdit.address.isLocked">
                            </div>
                        </div>
                        <div class="new_bairro" style="margin: 0px 5px 0px 5px;width: 5%;text-align: left;"><span>UF</span><div>
                            <div class="new-row">
                                <input class="input" style="max-width: 30px;" type="text" autocomplete="nope"
                                    :value="contactAddressToEdit && contactAddressToEdit.address && contactAddressToEdit.address.state ? contactAddressToEdit.address.state : ''"
                                    @input="updateValueContactAddressToEdit('address', 'state', $event.target.value)"
                                    :disabled="contactAddressToEdit.address.isLocked">
                                <div>
                                    <!-- <img style="margin: 10px 0px 0px 0px;cursor: pointer;" src="./Elements/ic-down.png"> -->
                                </div>
                            </div>
                        </div>
                        </div>
                    </div>
                    <div style="display:flex;flex-direction: row-reverse;margin-top:20px;" >
                        <div style="margin: 0px 5px 0px 5px;">
                            <input  class="new_button save-address" style="" type="button" @click="saveAddress(contactAddressToEdit)"  value="Salvar endereço">
                        </div>
                        <div style="margin: 0px 5px 0px 5px;">
                            <input class="new_button discard-address" type="button" value="voltar" @click="contactAddressForm = false">
                        </div>
                    </div>
                </div>
            </div>
            
        </div>
    </div>
</template>

<script>
import shortid from 'shortid'
import SearchAPI from '../../../../../api/search'
import _ from 'lodash'

import RequestContactSearchComponent from './RequestContactSearch.vue'
import SearchAddressComponent from '../../../../../components/Inputs/Search.vue'

export default {
    props: ['request'],
    components: {
        'app-search': SearchAddressComponent,
        'app-request-contact-search': RequestContactSearchComponent
    },
    data(){
        return{
            addressForceVisible: false,
            showComplement: false,
            activeContactTab: 'addresses',
            contactAddressForm: false,
            contactAddressToEdit: {},
            searchedAddresses: [],
            searchTimeout: null
        }
    },
    computed: {
        getContact(){
            return this.request.requestContact.contact
        },
        getContactAddresses(){
            return this.request.requestContact.contact.contactAddresses
        },
        getContactPhones(){
            return this.request.requestContact.contact.contactPhones
        },
        getContactPhoneDefault() {
            const contactPhones = _.get(this.request, 'requestContact.contact.contactPhones')
            if(contactPhones) return contactPhones.find(contactPhone => contactPhone.isDefault) || contactPhones[0]
        },
        addressSearchQuery(){
            const addressSearchQuery = _.result(this.contactAddressToEdit, 'address.name', false)
            if(addressSearchQuery){
                return addressSearchQuery.split(" ")
            }
            return []
        },
        getRequestTab() {
            return this.request.STATE_request.activeTab
        },
        getContactAddressDefault() {
            const contactAddresses = _.get(this.request, 'requestContact.contact.contactAddresses')
            if(contactAddresses)
                return contactAddresses.find(contactAddress => contactAddress.isDefault)
        }
    },
    methods:{
        redirectToWhatsapp(phoneNumber) {
            window.open(`https://wa.me/55${phoneNumber}`)
        },

        sanitizeSearch(text){
            return this.utils.removeDiacritics(text)
        },
        address(addressId) {
            if(addressId == null) return
            return this.VXORM.Address.query().where('id', addressId).first()
        },
        saveAddress(contactAddressEdit) {
            this.contactAddressForm = false
        },
        setContactAddressDefault(contactAddress) {
            this.request.requestContact.contact.contactAddresses.forEach(value => {
                this.VXORM.ContactAddress.update({
                    where: value.id,
                    data: {
                        isDefault: false
                    }
                })
            })
            this.VXORM.Request.updateModelValue(this.VXORM.ContactAddress, 'isDefault', contactAddress.id, !contactAddress.isDefault)
            this.VXORM.Request.updateModelValue(this.VXORM.RequestContact, 'contactAddressId', this.request.requestContactId, contactAddress.id)
        },
        setContactPhoneDefault(contactPhone) {
            this.request.requestContact.contact.contactPhones.forEach(value => {
                this.VXORM.ContactPhone.update({
                    where: value.id,
                    data: {
                        isDefault: false
                    }
                })
            })
            this.VXORM.Request.updateModelValue(this.VXORM.ContactPhone, 'isDefault', contactPhone.id, !contactPhone.isDefault)
            this.VXORM.Request.updateModelValue(this.VXORM.RequestContact, 'contactPhoneId', this.request.requestContactId, contactPhone.id)

        },
        editContactAddress(contactAddressId) {
            this.contactAddressForm = true
            this.contactAddressToEdit = this.VXORM.ContactAddress.query().with('address').find(contactAddressId)
        },
        async addContactAddress() {
            let addressTmpId = `tmp/${shortid.generate()}`

            await this.VXORM.Address.insert({ data: { id: addressTmpId } })
            let contactAddressToEdit = await this.VXORM.ContactAddress.insert({ data: 
                { id: `tmp/${shortid.generate()}`, contactId: this.getContact.id, addressId: addressTmpId } 
            })

            this.contactAddressToEdit = this.VXORM.ContactAddress.query().with('address').find(contactAddressToEdit.contactAddresses[0].id)
            this.contactAddressForm = true
        },
        async deleteContactAddress(contactAddress) {
            this.contactAddressForm = false
            if(this.request.requestContact.contact.contactAddresses.length <= 1) {
                let addressTmpId = `tmp/${shortid.generate()}`, contactAddressTmpId = `tmp/${shortid.generate()}`

                await this.VXORM.ContactAddress.insert({ 
                    data: { 
                        id: contactAddressTmpId, 
                        contactId: this.request.requestContact.contactId, 
                        isDefault: true,
                        addressId: addressTmpId,
                        address: { id: addressTmpId }
                    } 
                })
                this.editContactAddress(contactAddressTmpId)
            }
            if(contactAddress && contactAddress.id) {
                this.VXORM.ContactAddress.delete(contactAddress.id)
                this.VXORM.Address.delete(contactAddress.addressId)
            }
        },
        async updateValueContactAddressToEdit(modelName, fieldName, value) {
            if(modelName === 'address') {
                this.VXORM.Request.updateModelValue(this.VXORM.Address, fieldName, this.contactAddressToEdit.addressId, value.toUpperCase())
                this.contactAddressToEdit[modelName][fieldName] = value.toUpperCase()
                if(fieldName === 'name') {
                    if(this.searchTimeout) clearTimeout(this.searchTimeout)
                    this.searchTimeout = setTimeout(() => {
                        SearchAPI.searchAddresses(value).then(res => {
                            this.searchedAddresses = res.data.hits
                        }).catch(err => {
                            this.searchedAddresses = []
                        })
                    }, 500)
                }
            } else {
                this.contactAddressToEdit[fieldName] = value.toUpperCase()
                this.VXORM.Request.updateModelValue(this.VXORM.ContactAddress, fieldName, this.contactAddressToEdit.id, value.toUpperCase())
            }
        },
        addContactPhone() {
            this.VXORM.ContactPhone.insert({ data: { id: `tmp/${shortid.generate()}`, contactId: this.request.requestContact.contactId } })
        },
        deleteContactPhone(contactPhoneId) {
            if(this.request.requestContact.contact.contactPhones.length <= 1) 
                this.VXORM.ContactPhone.insert({ data: { id: `tmp/${shortid.generate()}`, contactId: this.request.requestContact.contactId, isDefault: true } })
            this.VXORM.ContactPhone.delete(contactPhoneId)
        },
        selectSearchedAddress(address) {
            console.log("is",this.contactAddressToEdit)
            this.VXORM.Address.delete({ where: this.contactAddressToEdit.addressId })
            this.VXORM.Address.insert({ data: { id: address.id, ...address.source } })
            this.VXORM.ContactAddress.update({ 
                where: this.contactAddressToEdit.id,
                data: {
                    addressId: address.id
                }
            })

            this.contactAddressToEdit = this.VXORM.ContactAddress.query().with('address').find(this.contactAddressToEdit.id)
        },
        deleteContact() {
            this.request.requestContact.contact.deleteAllInContact()

            const contactTmpId = "tmp/" + shortid.generate()
            const addressTmpId = "tmp/" + shortid.generate()

            this.request.STATE_request.$update({
                where: this.request.STATE_request.id,
                data: {
                    activeRequestOrderTab: 'products',
                    loadedRequestHistory: false,
                    requestHistory: {
                        list: [],
                        total: null
                    }
                }
            })
            
            this.request.requestContact.contact.$insert({ data: {
                id: contactTmpId,
                contactPhones: [{
                    id: "tmp/" + shortid.generate(),
                    contactId: contactTmpId,
                    isDefault: true
                }],
                contactAddresses: [{
                    id: "tmp/" + shortid.generate(),
                    isDefault: true,
                    contactId: contactTmpId,
                    addressId: addressTmpId,
                    address: { id: addressTmpId }
                }]
            } })

            this.request.requestContact.$update({
                where: this.request.requestContactId,
                data: {
                    contactId: contactTmpId
                }
            })

            this.contactAddressForm = false
        },
        deleteAddress() {
            this.VXORM.Address.delete({ where: this.contactAddressToEdit.addressId })

            const addressTmpId = "tmp/" + shortid.generate()
            this.VXORM.Address.insert({ data: { id: addressTmpId } })
            this.VXORM.ContactAddress.update({ 
                where: this.contactAddressToEdit.id,
                data: { 
                    addressId: addressTmpId
                }
            })

            this.contactAddressToEdit = this.VXORM.ContactAddress.query().with('address').find(this.contactAddressToEdit.id)
        },
    },
    mounted() {
        this.contactAddressForm = false
        this.$bus.$on('activeTabContact', () => {
            if(this.request.requestContact.contact.contactAddresses.length && !this.utils.isPersistedId(this.request.requestContact.contact.contactAddresses[0].id) && this.request.requestContact.contact.contactAddresses.length == 1) 
                this.editContactAddress(this.request.requestContact.contact.contactAddresses[0].id)
            else this.contactAddressForm = false
            if(!this.getContact.contactPhones.length) {
                this.VXORM.ContactPhone.insert({
                    data: {
                        id: `tmp/${shortid.generate()}`,
                        contactId: this.getContact.id
                    }
                })
            }
            if(!this.getContact.contactAddresses.length) {
                let addressId = `tmp/${shortid.generate()}`
                this.VXORM.Address.insert({
                    data: {
                        id: addressId
                    }
                })
                this.VXORM.ContactAddress.insert({
                    data: {
                        id: `tmp/${shortid.generate()}`,
                        contactId: this.getContact.id,
                        addressId
                    }
                })
            }
        })
    }
}
</script>

<style lang="scss">
input {
    font-size: 15px !important;
}

input::placeholder {
    font-size: 15px !important;
}

.request-contact__body {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    padding: 70px 10px 0px 10px;
    background: #161A1D; 
}

.new-column{
    display: flex;
    flex-direction: column;
    flex-grow: 1;
}

.new-row{
    display: flex;
    flex-direction: row;
    align-content: center;
}

.new-contato{
    background: #23272B;
    border-radius: 2px;
    margin: 0px 5px 0px 0px;
    padding: 10px;
    .text-span{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: 17px;
    color: #73777B;
    }
    .text-grand-span{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 17px;
    color: white;
    }
    text-align: left;
}

.new-telefone{
    background: #23272B;
    border-radius: 2px;
    margin: 0px 0px 0px 5px;
    padding: 10px;
    max-width: 220px;
    flex-shrink: 0;
    text-align: left;
    .text-span{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 17px;
    color: #73777B;   
    text-align: left; 
    }
    .stylo-new-span{
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    line-height: 17px;
    color: white;
    }
}

.new-body__contact-tabs{
    margin-top: 10px;
}

.endereço{
    padding: 7px 10px 5px 12px;
    background: #31363C;
    border-radius: 2px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    height: 32px;
    cursor: pointer;
}

.detalhes{
    padding: 7px 10px 5px 12px;
    background: #31363C;
    border-radius: 2px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    height: 32px;
    cursor: pointer;
}

.endereço.ativo, .detalhes.ativo{
    background: #23272B;
}

.new-form {
    height: auto;
    background: #23272B;
    padding: 10px;
    border-radius: 2px;
}

span {
    font-family: Arial, Helvetica, sans-serif;
    font-size: 14px;
    line-height: normal;
    color: #73777B;
}

.input-contact{
    border: 0px;
    background: transparent;
    width: 100%;
    height: 30px;
    margin-top: -10px;
    margin-bottom: -10px;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 18px;
    color: white;
    outline-style: none;
}

.input-contact::placeholder {
}


.new_bairro{
    border-bottom: 2px solid #373C42;
    span{
        font-family: Arial, Helvetica, sans-serif;
        font-size: 14px;
        line-height: normal;
        color: #73777B;    
    }
    input[type="text"], input[type="number"] {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 18px;
        color: #E7E8E8;
        background: transparent;
        border: 0px;
        outline-style: none;
    }
}

.new-column{
    display: flex;
    flex-direction: column;
}
.new-row{
    display: flex;
    flex-direction: row; 
    align-content: center;
}
.numero{
    display: flex;
    margin: 0px 0 0 10px;
    max-width: 50px ;
    flex-shrink: 0;
    input[type="text"], input[type="number"] {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 18px;
        color: #E7E8E8;
        background: transparent;
        border: 0px;
        max-width: 40px;
    }
}
.new-inputs{
    border-bottom: 2px solid #373C42;
    display: flex;
    flex-direction: row;
    align-items: center;
    margin: 0;
    outline-style: none;
    input[type="text"], input[type="number"] {
        font-family: Arial, Helvetica, sans-serif;
        font-size: 18px;
        color: #E7E8E8;
        background: transparent;
        border: 0px;
        width: 100%;
    }
}
.button-img{
    max-width: 132px;
    padding: 7px 10px 5px 5px;
    margin-top: 20px;
    display: flex;
    height: 32px;
    background: #31363C;
    border-radius: 5px;
    justify-content: center;
    cursor: pointer;
    img{
        margin-right: 5px;
    }
    &:hover {
        background: linear-gradient(89.54deg, #0072E4 -0.59%, #25A0A8 100.95%);
        span {
            color: white;
        }
        .ic-complement {
            opacity: 1;
        }
    } 
}


.new-input-contato{
    border: 1px solid #73777B;
    border-radius: 5px;
    background: #23272B;
    color: #73777B;
    font-family: Arial, Helvetica, sans-serif;
    font-size: 17px;
    padding: 5px 10px 5px 10px; 
}
.new-caixa-input{
    display: flex;
    flex-direction:row;
    align-items: center;
}

.new_button{
background: #373C42;
border-radius: 2px;
font-family: Arial, Helvetica, sans-serif;
font-size: 12px;
color: #73777B;
height: 24px;
border: 0px;
cursor: pointer;
}

.complementActivated {
    background: #4D76C8;
    span {
        color: white;
    }
    .ic-complement {
        opacity: 1;
    }
}

.ic-complement {
    opacity: .3;
}

.discard-address:hover {
    background: #E0634A;
    color: white;
}

.save-address {
    background: #4D76C8; 
    color: white
}

.save-address:hover {
    background: linear-gradient(89.05deg, #0072E4 -0.59%, #25A0A8 100.95%);
    color: white;
}

.is-default {
    color: #4D76C8;
}

.block-container {
    width: 100%; 
    height: 100%; 
    position: absolute; 
    z-index: 9999;
}

.disabled {
    pointer-events: none;
}

.request-contact__body-zepplin {
    padding: 10px 10px 0px 10px;
}

.input {
    padding-left: 0px !important;
}
</style>